import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Select, Icon, Form } from 'antd';
import './NewFilter.style.less';

import { FILTER_TYPE } from 'shared/constant';
import NewFilterText from './NewFilterText.component';
import NewFilterRangeInput from './NewFilterRangeInput.component';
import NewFilterDatePicker from './NewFilterDatePicker.component';
import NewFilterRangePicker from './NewFilterRangePicker.component';
import NewFilterRadio from './NewFilterRadio.component';

const { Option, OptGroup } = Select;
const NewFilterTextForm = Form.create({ name: 'newFilterTextForm' })(
  NewFilterText,
);
const NewFilterRangeInputForm = Form.create({ name: 'newFilterRangeInput' })(
  NewFilterRangeInput,
);
const NewFilterDatePickerForm = Form.create({
  name: 'newFilterDatePickerForm',
})(NewFilterDatePicker);
const NewFilterRangePickerForm = Form.create({
  name: 'newFilterRangePickerForm',
})(NewFilterRangePicker);
const NewFilterRadioForm = Form.create({
  name: 'newFilterRadioForm',
})(NewFilterRadio);

class NewFilter extends PureComponent {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  setFilterDropdownShow = show => {
    const { setFilterDropdownShow } = this.props;
    setFilterDropdownShow(show);
  };

  getOnSelectOptionLabel = selectedOption => {
    let result = '';
    const { label } = selectedOption;
    switch (selectedOption.type) {
      case FILTER_TYPE.RANGE_PICKER:
      case FILTER_TYPE.RANGE_INPUT:
        result += `${label} from`;
        break;
      case FILTER_TYPE.BOOL:
        result += `Show ${label}`;
        break;
      default:
        result += `${label} is`;
        break;
    }

    return result;
  };

  getOptionBySelectedKey = key => {
    const { options } = this.props;
    let result;
    for (let i = 0; i < options.length; i += 1) {
      if (options[i].children) {
        for (let j = 0; j < options[i].children.length; j += 1) {
          const child = options[i].children[j];
          if (child.value === key) {
            result = { ...child };
            break;
          }
        }
      } else if (result) {
        break;
      } else if (options[i].value === key) {
        result = options[i];
        break;
      }
    }

    return result;
  };

  removeLastFilterValue = () => {
    const { filterValue } = this.props;
    const newFilterValue = [...filterValue];

    const lastIndex = newFilterValue.length - 1;
    newFilterValue.splice(lastIndex, 1);

    return newFilterValue;
  };

  updateLastFilterValue = (value, customLabel) => {
    const { filterValue } = this.props;
    const newFilterValue = [...filterValue];

    const lastIndex = newFilterValue.length - 1;

    if (Array.isArray(value)) {
      newFilterValue[lastIndex].inputValue = [...value];
    } else {
      newFilterValue[lastIndex].inputValue.push(value);
    }

    if (customLabel) {
      newFilterValue[lastIndex].label += ` ${customLabel}`;
    } else {
      newFilterValue[lastIndex].label += ` ${value}`;
    }

    return newFilterValue;
  };

  onFocusSelect = () => {
    const { filterDropdownShow } = this.props;
    if (!filterDropdownShow) {
      this.setFilterDropdownShow(true);
    }
  };

  onBlurSelect = () => {
    const { filterDropdownShow } = this.props;

    if (filterDropdownShow) {
      this.setFilterDropdownShow(false);
    }

    this.selectRef.current.blur();
  };

  onSelectOption = selected => {
    const { setFormControlShow, filterValue, onAddFilter } = this.props;

    const newFilterValue = [...filterValue];
    const newSelectedValue = { ...selected };

    const selectedOption = this.getOptionBySelectedKey(selected.key);

    newSelectedValue.options = selectedOption.options;
    newSelectedValue.validations = selectedOption.validations;
    newSelectedValue.type = selectedOption.type;
    newSelectedValue.label = this.getOnSelectOptionLabel(selectedOption);

    if (selectedOption.type === FILTER_TYPE.BOOL) {
      newSelectedValue.inputValue = ['true'];

      newFilterValue.push(newSelectedValue);
      setFormControlShow(false, newFilterValue);

      if (onAddFilter) {
        onAddFilter(newFilterValue);
      }
    } else {
      newSelectedValue.inputValue = [];

      newFilterValue.push(newSelectedValue);
      setFormControlShow(true, newFilterValue);
    }

    this.selectRef.current.blur();
  };

  onDeselectOption = deselectValue => {
    const { setFilterValue, onRemoveFilter } = this.props;
    const newFilterValue = this.getNewDeselectFilterValue(deselectValue);

    setFilterValue(newFilterValue);

    if (onRemoveFilter) {
      onRemoveFilter(newFilterValue);
    }
  };

  getUnselectedOptions = () => {
    const { options, filterValue } = this.props;

    const result = [];
    for (let i = 0; i < options.length; i += 1) {
      const option = options[i];
      let isSelected = false;

      if (option.children) {
        const unselectedChildrens = option.children.filter(
          child => !filterValue.some(value => value.key === child.value),
        );

        if (unselectedChildrens && unselectedChildrens.length > 0) {
          const newOption = { ...option };
          newOption.children = unselectedChildrens;
          result.push(newOption);
        }
      } else {
        for (let j = 0; j < filterValue.length; j += 1) {
          if (options[i].value === filterValue[j].key) {
            isSelected = true;
            break;
          }
        }

        if (!isSelected) {
          result.push(option);
        }
      }
    }

    return result;
  };

  getNewDeselectFilterValue = deselectValue => {
    const { filterValue } = this.props;

    let result = [...filterValue];
    result = result.filter(x => x.key !== deselectValue.key);

    return result;
  };

  renderOptions = () => {
    const options = this.getUnselectedOptions();

    const childArr = [];
    let tempArr = [];
    options.forEach((item, index) => {
      if (item.children) {
        childArr.push(<OptGroup label="Add Filter">{tempArr}</OptGroup>);
        tempArr = [];
        childArr.push(this.renderOptionGroup(item));
      } else {
        const key = `${item.label}-${index}`;
        tempArr.push(
          <Option key={key} value={item.value}>
            {item.label}
          </Option>,
        );
      }
    });

    childArr.push(
      <OptGroup key="group_filter_key" label="Add Filter">
        {tempArr}
      </OptGroup>,
    );

    return childArr;
  };

  renderOptionGroup = option => {
    const childrens = option.children;
    return (
      <OptGroup label={option.optGroupLabel}>
        {childrens.map((x, index) => {
          const key = `${x.label}-${index}`;
          return (
            <Option key={key} value={x.value}>
              {x.label}
            </Option>
          );
        })}
      </OptGroup>
    );
  };

  renderFormControlElement = element => {
    switch (element.type) {
      case FILTER_TYPE.DATE_PICKER:
        return (
          <NewFilterDatePickerForm
            onCancelForm={this.cancelFormControl}
            onSubmitForm={this.submitFormControl}
          />
        );
      case FILTER_TYPE.RANGE_PICKER:
        return (
          <NewFilterRangePickerForm
            onCancelForm={this.cancelFormControl}
            onSubmitForm={this.submitFormControl}
            options={element.options}
          />
        );
      case FILTER_TYPE.RADIO:
        return (
          <NewFilterRadioForm
            onCancelForm={this.cancelFormControl}
            onSubmitForm={this.submitFormControl}
            options={element.options}
          />
        );
      case FILTER_TYPE.RANGE_INPUT:
        return (
          <NewFilterRangeInputForm
            onCancelForm={this.cancelFormControl}
            onSubmitForm={this.submitFormControl}
            options={element.options}
          />
        );
      case FILTER_TYPE.TEXT:
      default:
        return (
          <NewFilterTextForm
            onCancelForm={this.cancelFormControl}
            onSubmitForm={this.submitFormControl}
            label={element.label}
            validations={element.validations}
          />
        );
    }
  };

  renderFormControl = () => {
    const { filterValue, formControlShow } = this.props;
    if (filterValue.length > 0 && formControlShow) {
      const element = filterValue[filterValue.length - 1];
      const formControl = this.renderFormControlElement(element);

      return <div className="form-control">{formControl}</div>;
    }

    return null;
  };

  cancelFormControl = () => {
    const { setFormControlShow } = this.props;
    const newFilterValue = this.removeLastFilterValue();

    setFormControlShow(false, newFilterValue);
  };

  submitFormControl = (inputValue, customLabel) => {
    const { setFormControlShow, onAddFilter } = this.props;
    const newFilterValue = this.updateLastFilterValue(inputValue, customLabel);

    setFormControlShow(false, newFilterValue);

    if (onAddFilter) {
      onAddFilter(newFilterValue);
    }
  };

  render = () => {
    const { filterDropdownShow, filterValue, formControlShow } = this.props;
    const options = this.renderOptions();
    const formControl = this.renderFormControl();

    return (
      <div className="new-filter-wrapper">
        <div>
          <Icon type="search" className="search-icon" />
        </div>
        <div className="div-select">
          <Select
            ref={this.selectRef}
            style={{ width: '100%' }}
            mode="multiple"
            placeholder="Search or Add Filters"
            showArrow={false}
            labelInValue
            value={filterValue}
            open={filterDropdownShow}
            onFocus={this.onFocusSelect}
            onSelect={this.onSelectOption}
            onDeselect={this.onDeselectOption}
            onBlur={this.onBlurSelect}
            disabled={formControlShow}
          >
            {options}
          </Select>
          {formControl}
        </div>
      </div>
    );
  };
}

NewFilter.propTypes = {
  filterDropdownShow: PropTypes.bool,
  setFilterDropdownShow: PropTypes.func,
  options: PropTypes.array,
  filterValue: PropTypes.array,
  setFormControlShow: PropTypes.func,
  formControlShow: PropTypes.bool,
  onAddFilter: PropTypes.func,
  onRemoveFilter: PropTypes.func,
  setFilterValue: PropTypes.func,
};

export default NewFilter;
